import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "actions" }
const _hoisted_2 = {
  id: "reportView",
  class: "content"
}

import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import store from "@/store";

import { toast } from "@/common/utils/toast";
import { generatePDF } from "@/common/utils/pdf";

import { analysisReport } from "@/common/api/rest/analysis/analysis";

import type { AnalysisFullType } from "@/common/types/analysis";

import { sidebarListCheckbox, svgIcon } from "@/common/components";
import { viewReportAnalyse } from "@/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'report',
  props: {
    accountId: {},
    analysisId: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "v50acc4eb": (width.value),
  "v5071a06f": (scale.value)
}))

const { t } = useI18n();
const route = useRoute();

const props = __props;

const width = ref("210mm");
const analyse = ref<AnalysisFullType | null>(null);
const key = ref(0);

const added = ref<string[]>([
  "company",
  "analyse",
  "employee",
  "method",
  "sample",
  "equipment",
  "signature",
]);

const showFilter = ref(false);

const accountId = computed(() => route.params.id as string);

const list = computed(() => [
  {
    key: "all",
    label: "Selecionar Tudo",
  },
  {
    key: "company",
    label: "Dados da Empresa",
  },
  {
    key: "analyse",
    label: "Dados da Análise",
  },
  {
    key: "employee",
    label: "Funcionário",
  },
  {
    key: "method",
    label: "Métodos",
  },
  {
    key: "form_question",
    label: "Perguntas dos Formulários",
  },
  {
    key: "method_question",
    label: "Perguntas dos Métodos",
  },
  {
    key: "sample",
    label: "Amostras",
  },
  {
    key: "equipment",
    label: "Equipamentos",
  },
  {
    key: "signature",
    label: "Assinaturas",
  },
]);

const scale = computed(() => {
  const width = window.innerWidth;

  if (store.getters.reportScale) return 1;

  if (width >= 1444) return 1;

  if (width >= 1366 && width < 1444) return 0.875;

  if (width >= 1024 && width < 1366) return 0.75;

  if (width > 800 && width < 1024) return 0.75;

  if (width <= 800) return 0.47;

  return 1;
});

async function fetchData() {
  if (!props.analysisId) return;

  await analysisReport(accountId.value, props.analysisId)
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        analyse.value = data;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

async function printPage() {
  store.commit("SET_REPORT_SCALE", true);
  store.commit("SET_LOADING", true);
  store.commit("SET_PRINT", true);

  const element = document.getElementById("reportView");
  if (!element) {
    store.commit("SET_REPORT_SCALE", null);
    store.commit("SET_LOADING", false);
    return;
  }

  await new Promise((resolve) => {
    setTimeout(async () => {
      resolve(true);
    }, 1000);
  });

  await generatePDF(element, `analyse-${analyse.value?.code}.pdf`);

  setTimeout(async () => {
    store.commit("SET_REPORT_SCALE", null);
    store.commit("SET_LOADING", false);
    store.commit("SET_PRINT", false);
  }, 1000);
}

function openFilter() {
  showFilter.value = true;
}

function closeFilter() {
  showFilter.value = false;
}

function addFilter(item: any) {
  if (added.value.includes(item.key)) {
    return;
  }

  if (item.key === "all") {
    added.value = list.value.map((i) => i.key);
    key.value += 1;
    return;
  }

  added.value.push(item.key);

  const allKey = list.value.map((i) => i.key).filter((key) => key !== "all");
  if (added.value.length === allKey.length) {
    added.value.push("all");
  }

  key.value += 1;
}

function removeFilter(item: any) {
  if (item.key === "all") {
    added.value = [];
    key.value += 1;
    return;
  }

  added.value = added.value
    .filter((key) => key !== item.key)
    .filter((key) => key !== "all");

  key.value += 1;
}

onMounted(() => {
  fetchData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", {
    class: _normalizeClass(["analysis-report", {
      print: _ctx.$store.getters.reportScale,
    }])
  }, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn btn-default",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (openFilter()))
      }, [
        _createVNode(_unref(svgIcon), {
          icon: "filter",
          size: "1.5rem"
        }),
        _createTextVNode(" " + _toDisplayString(_unref(t)("common.labels.filters")), 1)
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn btn-default",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (printPage()))
      }, [
        _createVNode(_unref(svgIcon), {
          icon: "download",
          size: "1.5rem"
        }),
        _createTextVNode(" " + _toDisplayString(_unref(t)("common.labels.download")), 1)
      ])
    ]),
    _createElementVNode("section", _hoisted_2, [
      (analyse.value)
        ? (_openBlock(), _createBlock(_unref(viewReportAnalyse), {
            key: key.value,
            data: analyse.value,
            scale: scale.value,
            width: width.value,
            filters: added.value
          }, null, 8, ["data", "scale", "width", "filters"]))
        : _createCommentVNode("", true)
    ]),
    (showFilter.value)
      ? (_openBlock(), _createBlock(_unref(sidebarListCheckbox), {
          key: 0,
          id: "franchise",
          width: _ctx.$store.getters.mobile ? '90vw' : '40rem',
          open: showFilter.value,
          "outside-close": true,
          title: _unref(t)('common.labels.filters'),
          list: list.value,
          "field-id": "key",
          "field-option": "label",
          added: added.value,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (closeFilter())),
          "onAdd:item": addFilter,
          "onRemove:item": removeFilter
        }, null, 8, ["width", "open", "title", "list", "added"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})